import type { default as MsHighContrastStore } from "./schema/MsHighContrastStore";
import { type MsHighContrastMode } from "./schema/MsHighContrastMode";
import { createStore } from "owa-satcheljs";

const defaultMsHighContrastStore: MsHighContrastStore = {
    mode: 0,
    isTeamsHighContrast: false,
};

const initialStore = { ...defaultMsHighContrastStore };
export const getStore: () => MsHighContrastStore = createStore<MsHighContrastStore>("msHighContrastStore", initialStore);
